import { datadogRum } from "@datadog/browser-rum";

export default defineNuxtPlugin((nuxtApp) => {
  const { ddApplicationId, ddClientToken, ddEnv, ddVersion } =
    nuxtApp.$config.public;
  datadogRum.init({
    applicationId: ddApplicationId,
    clientToken: ddClientToken,
    site: "datadoghq.eu",
    service: "cisco-forms",
    env: ddEnv,
    version: ddVersion,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 20,
    defaultPrivacyLevel: "mask-user-input",
  });
  datadogRum.startSessionReplayRecording();
});
